export function openRazorpay(options) {
  return new Promise((resolve, reject) => {
    const loadSdk = () => new Promise((res, rej) => {
      if (window.Razorpay) return res();
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = res; s.onerror = () => rej(new Error("Razorpay SDK failed to load"));
      document.body.appendChild(s);
    });
    loadSdk().then(() => {
      const rzp = new window.Razorpay({
        ...options,
        handler: (response) => resolve(response),
        modal:   { ondismiss: () => reject(new Error("Payment cancelled")) },
      });
      rzp.on("payment.failed", (r) => reject(r.error));
      rzp.open();
    }).catch(reject);
  });
}

/**
 * Generic Razorpay flow used by both bookings and product orders.
 *
 * @param {Object}  args
 * @param {string}  args.ref          — booking_ref or order_ref (label only)
 * @param {Object}  args.user         — for prefill (name/email/phone)
 * @param {Function} args.onInitiate  — async (ref) => server initiate response
 * @param {Function} args.onVerify    — async (sigData) => server verify response
 * @param {string} [args.description] — Razorpay modal description (defaults to "Booking #<ref>")
 * @param {string} [args.bookingRef]  — back-compat alias for `ref`
 */
export async function processPayment({ ref, bookingRef, user, onInitiate, onVerify, description }) {
  const refValue = ref ?? bookingRef;
  const orderData      = await onInitiate(refValue);
  const paymentResponse= await openRazorpay({
    key:         orderData.key_id,
    amount:      orderData.amount,
    currency:    orderData.currency || "INR",
    order_id:    orderData.order_id,
    name:        "Fayriza",
    description: description || `Booking #${refValue}`,
    prefill:     { name: user?.name || "", email: user?.email || "", contact: user?.phone || "" },
    theme:       { color: "#C9A84C" },
  });
  return await onVerify({
    razorpay_order_id:   paymentResponse.razorpay_order_id,
    razorpay_payment_id: paymentResponse.razorpay_payment_id,
    razorpay_signature:  paymentResponse.razorpay_signature,
  });
}
